// extracted by mini-css-extract-plugin
module.exports = {"product-list-page__header":"OgpV536H","productListPage__header":"OgpV536H","h1":"_1A-eT8h7","link-back":"_2VJOEisH","linkBack":"_2VJOEisH"};